/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mesafeli_S3_Plans_BodyInputs */

const tr_mesafeli_s3_plans_body = /** @type {(inputs: Mesafeli_S3_Plans_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Başlangıç (Starter), Profesyonel (Pro) ve Kurumsal (Enterprise) olarak Platform üzerinde ilan edilen paketler. Plan içerikleri ve fiyatları shoppanel.emonse.com/fiyatlandirma sayfasında güncel olarak yayımlanır.`)
};

const en_mesafeli_s3_plans_body = /** @type {(inputs: Mesafeli_S3_Plans_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The packages announced on the Platform as Başlangıç (Starter), Profesyonel (Pro) and Kurumsal (Enterprise). Plan contents and prices are published in their current form on the page shoppanel.emonse.com/fiyatlandirma.`)
};

const de_mesafeli_s3_plans_body = /** @type {(inputs: Mesafeli_S3_Plans_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Die auf der Plattform veröffentlichten Pakete Başlangıç (Starter), Profesyonel (Pro) und Kurumsal (Enterprise). Planinhalte und Preise werden jeweils aktuell auf der Seite shoppanel.emonse.com/fiyatlandirma veröffentlicht.`)
};

const ru_mesafeli_s3_plans_body = /** @type {(inputs: Mesafeli_S3_Plans_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Пакеты, объявленные на Платформе как Başlangıç (Starter), Profesyonel (Pro) и Kurumsal (Enterprise). Содержание планов и цены публикуются в актуальном виде на странице shoppanel.emonse.com/fiyatlandirma.`)
};

/**
* | output |
* | --- |
* | "The packages announced on the Platform as Başlangıç (Starter), Profesyonel (Pro) and Kurumsal (Enterprise). Plan contents and prices are published in their c..." |
*
* @param {Mesafeli_S3_Plans_BodyInputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const mesafeli_s3_plans_body = /** @type {((inputs?: Mesafeli_S3_Plans_BodyInputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mesafeli_S3_Plans_BodyInputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_mesafeli_s3_plans_body(inputs)
	if (locale === "de") return de_mesafeli_s3_plans_body(inputs)
	if (locale === "ru") return ru_mesafeli_s3_plans_body(inputs)
	return tr_mesafeli_s3_plans_body(inputs)
});